<span class="icon" [ngClass]="data.type"></span>
<span class="message" [innerHTML]="message"></span>